import script from "./ProfessionsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionsScreen.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionsScreen.vue?vue&type=style&index=0&id=6adf98fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6adf98fc"]])

export default __exports__